export default __webpack_public_path__ + "static/media/instagram.ccb15e44.svg";